import { CONTENT_OPTIONS, WEEKDAYS, KENKYU_SHUBETSU, KENKYU_MOKEI, Representative_Class, SHOZOKU_LIST } from '../shared/constants';

export default function WorkTable({ rows, year, month, onToggle, onUpdate, totalH, totalM, estimatedPay, hourlyWage }) {
  const fmt = (n) => n.toLocaleString("ja-JP");

  // 時間選択用コンポーネント（"HH:MM" を受け渡す）
  const hours = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
  const minutes = ["00", "15", "30", "45"];
  function TimeInput({ value = "", onChange }) {
    const [hh, mm] = value ? value.split(":") : ["", ""];
    return (
      <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
        <select
          className="time-select"
          value={hh || ""}
          onChange={e => {
            const nh = e.target.value;
            if (!nh) return onChange("");
            const nm = mm || "00";
            onChange(`${nh}:${nm}`);
          }}
        >
          <option value="">--</option>
          {hours.map(h => <option key={h} value={h}>{h}</option>)}
        </select>
        :
        <select
          className="time-select"
          value={mm || ""}
          onChange={e => {
            const nm = e.target.value;
            if (!nm) return onChange("");
            const nh = hh || "00";
            onChange(`${nh}:${nm}`);
          }}
        >
          <option value="">--</option>
          {minutes.map(m => <option key={m} value={m}>{m}</option>)}
        </select>
      </div>
    );
  }

  return (
    <div>
      {/* サマリーバー */}
      <div className="summary-bar" style={{marginBottom:12}}>
        <div className="summary-item">
          <span className="summary-label">合計従事時間</span>
          <span className="summary-value">{totalH}時間{totalM > 0 ? `${totalM}分` : ""}</span>
        </div>
        <div className="summary-item">
          <span className="summary-label">時給</span>
          <span className="summary-value">¥{fmt(hourlyWage)}</span>
        </div>
        <div className="summary-item summary-total">
          <span className="summary-label">概算支給額（税引前）</span>
          <span className="summary-value total-value">¥{fmt(estimatedPay)}</span>
        </div>
      </div>

      <div className="card" style={{padding:0,overflow:"hidden"}}>
        <div className="table-scroll">
          <table className="work-table">
            <thead>
              <tr>
                <th className="th-check">勤務</th>
                <th className="th-day">日</th>
                <th className="th-wd">曜</th>
                <th className="th-time">開始</th>
                <th className="th-time">終了</th>
                <th className="th-time">休憩</th>
                <th className="th-time">従事<br/>時間</th>
                <th className="th-content">業務内容（選択 or 自由入力）</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => {
                const isSat = row.weekday === "土";
                const isSun = row.weekday === "日";
                const rowCls = `work-row${row.active ? " active" : ""}${isSat ? " sat" : isSun ? " sun" : ""}`;
                return (
                  <tr key={idx} className={rowCls}>
                    <td className="td-check">
                      <input type="checkbox" checked={row.active} onChange={() => onToggle(idx)} />
                    </td>
                    <td className="td-day">{row.day}</td>
                    <td className={`td-wd ${isSat ? "sat-text" : isSun ? "sun-text" : ""}`}>{row.weekday}</td>

                    {row.active ? (
                      <>
                        <td className="td-time">
                          <TimeInput value={row.startTime} onChange={v => onUpdate(idx, "startTime", v)} />
                        </td>
                        <td className="td-time">
                          <TimeInput value={row.endTime} onChange={v => onUpdate(idx, "endTime", v)} />
                        </td>
                        <td className="td-time">
                          <TimeInput value={row.breakTime} onChange={v => onUpdate(idx, "breakTime", v)} />
                        </td>
                        <td className="td-time calc-cell">{row.workHours || "−"}</td>
                        <td className="td-content">
                          <div className="content-wrap">
                            <select
                              className="content-select"
                              value={CONTENT_OPTIONS.includes(row.content) ? row.content : "__custom"}
                              onChange={e => {
                                if (e.target.value !== "__custom") onUpdate(idx, "content", e.target.value);
                                else onUpdate(idx, "content", "");
                              }}
                            >
                              <option value="__custom">── 自由入力 ──</option>
                              {CONTENT_OPTIONS.map(o => <option key={o} value={o}>{o}</option>)}
                            </select>
                            {(!CONTENT_OPTIONS.includes(row.content)) && (
                              <input
                                className="content-input"
                                type="text"
                                value={row.content}
                                onChange={e => onUpdate(idx, "content", e.target.value)}
                                placeholder="具体的な業務内容を入力（例：○○に関する△△調査）"
                              />
                            )}
                          </div>
                        </td>
                      </>
                    ) : (
                      <td colSpan={5} className="td-inactive">← チェックを入れて勤務日を有効化</td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
